export const TICKET_ACTIONS = {
  OPEN_TICKET: "open-ticket",
  CLOSE_TICKET: "close-ticket",
  SET_TICKET_INFO: "set-ticket-info",
  UPDATE_TICKET: "update-ticket",
  // UPDATE_TICKET_PERSON: 'update-ticket-person' // Deprecated
};
